import script from "./SortingBox.vue?vue&type=script&setup=true&lang=js"
export * from "./SortingBox.vue?vue&type=script&setup=true&lang=js"

import "./SortingBox.vue?vue&type=style&index=0&id=f796e358&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f796e358"]])

export default __exports__